<div class="grid-x">
  <div class="cell small-12 checkbox">
    <input class="show-for-sr" type="checkbox" [id]="useDefaultValue" [name]="useDefaultValue" [(ngModel)]="useDefaultValue" (ngModelChange)="changeDefault()">
    <label [for]="useDefaultValue">
      <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
      <span class="label-text">  Default Value</span>
    </label>
  </div>
</div>
@if (useDefaultValue) {
  <div class="grid-x">
    <div class="cell small-12">
      Default Value:
    </div>
    <div class="cell small-12">
      <input type="radio" name="defaultOption" [(ngModel)]="defaultValue" value="checked" (ngModelChange)="changeDefault()" /> Checked
    </div>
    <div class="cell small-12">
      <input type="radio" name="defaultOption" [(ngModel)]="defaultValue" value="unchecked" (ngModelChange)="changeDefault()" /> Unchecked
    </div>
  </div>
}
<div class="grid-x">
  <div class="cell small-12">
    Display in Summary as (checked/not checked):
  </div>
  @for (option of displayOptions; track option) {
    <div class="cell small-12">
      <input type="radio" name="display" [(ngModel)]="summaryDisplayType" [value]="option.type" />&nbsp;&nbsp;{{option.type}}
    </div>
  }
</div>
@if (summaryDisplayType === 'Other') {
  <div class="grid-x">
    <div class="cell small-3 vertical-align-middle">Checked:</div><div class="cell small-3"><input type="text" [(ngModel)]="summaryOptionOtherChecked" /></div>
    <div class="cell small-3 vertical-align-middle">Unchecked:</div><div class="cell small-3"><input type="text" [(ngModel)]="summaryOptionOtherUnchecked" /></div>
  </div>
}
